import React from 'react';
import { ShieldCheckIcon, TruckIcon, ZapIcon, ArrowRightIcon } from 'lucide-react';
import { trackCustom } from '../tracking/metaPixel';
import { useLanguage } from '../../context/LanguageContext';
import { getWhatsAppLink } from '../../utils/whatsappLink';
const VehicleRecommendations = () => {
  const {
    t,
    language
  } = useLanguage();
  const handleCardClick = (category: string) => {
    trackCustom('VehicleInterest', {
      category,
      language,
      action: 'scroll_to_form'
    });
    // Smooth scroll to form
    const form = document.getElementById('lead-form');
    if (form) {
      form.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const icons = [<ShieldCheckIcon className="w-5 h-5 text-primary" data-id="element-356" />, <TruckIcon className="w-5 h-5 text-primary" data-id="element-357" />, <ZapIcon className="w-5 h-5 text-primary" data-id="element-358" />];
  // Keeping existing images but ensuring they map correctly to new categories
  // 1. Subaru (using the first image)
  // 2. GMC/Buick (using the second image)
  // 3. Hyundai (using the third image)
  const images = ['https://cdn.magicpatterns.com/uploads/6DToN9caXDD8zvgB41oZGB/Screenshot_2026-02-06_at_5.50.38_AM.png', 'https://cdn.magicpatterns.com/uploads/2AMuADdYoFgDtqikopWwYg/Screenshot_2026-02-06_at_5.44.37_AM.png', 'https://cdn.magicpatterns.com/uploads/hHnFUtuKwCjZdun3oe5cH1/Screenshot_2026-02-06_at_5.45.49_AM.png'];
  return <section className="py-20 px-4 bg-gray-50 border-t border-gray-100" data-id="element-359">
      <div className="container mx-auto" data-id="element-360">
        <div className="text-center mb-16" data-id="element-361">
          <span className="inline-block py-1 px-3 rounded-full bg-primary/5 text-primary text-xs font-bold tracking-widest uppercase mb-4" data-id="element-362">
            Inventario Premium
          </span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-primary mb-6" data-id="element-363">
            {t.vehicles.headline}
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg leading-relaxed" data-id="element-364">
            {t.vehicles.subheadline}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-10" data-id="element-365">
          {t.vehicles.categories.map((cat, idx) => <div key={idx} className="group bg-white rounded-xl overflow-hidden shadow-[0_2px_16px_rgba(0,0,0,0.06)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.12)] transition-all duration-300 border border-gray-100 flex flex-col h-full" data-id="element-366">
              {/* Image Area */}
              <div className="relative aspect-[16/10] overflow-hidden bg-gray-100" data-id="element-367">
                <img src={images[idx]} alt={cat.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-368" />
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-80" data-id="element-369"></div>

                {/* Brand Badge */}
                <div className="absolute top-4 left-4 bg-primary/90 backdrop-blur-sm text-white text-xs font-bold px-3 py-1.5 rounded shadow-sm tracking-wide uppercase" data-id="element-370">
                  {cat.title}
                </div>
              </div>

              {/* Content Area */}
              <div className="p-8 flex-1 flex flex-col" data-id="element-371">
                <div className="flex items-start justify-between mb-4" data-id="element-372">
                  <div data-id="element-373">
                    <h3 className="font-heading font-bold text-xl text-primary mb-1" data-id="element-374">
                      {cat.subtitle}
                    </h3>
                    <div className="h-1 w-12 bg-accent rounded-full" data-id="element-375"></div>
                  </div>
                  <div className="p-2 bg-gray-50 rounded-lg border border-gray-100 text-primary" data-id="element-376">
                    {icons[idx]}
                  </div>
                </div>

                <p className="text-gray-600 mb-6 text-sm leading-relaxed" data-id="element-377">
                  {cat.description}
                </p>

                {/* Models Tags */}
                <div className="flex flex-wrap gap-2 mb-8" data-id="element-378">
                  {cat.models && cat.models.map((model, i) => <span key={i} className="text-[11px] font-semibold bg-gray-50 border border-gray-200 text-gray-600 px-2.5 py-1 rounded-md uppercase tracking-wide" data-id="element-379">
                        {model}
                      </span>)}
                </div>

                {/* CTA Area - pinned to bottom */}
                <div className="mt-auto pt-6 border-t border-gray-100" data-id="element-380">
                  <button onClick={() => handleCardClick(cat.title)} className="w-full flex items-center justify-center gap-2.5 bg-primary hover:bg-secondary text-white font-bold text-sm tracking-wide h-14 px-5 rounded-[14px] shadow-sm hover:shadow-md transition-all duration-200" data-id="element-381">
                    <span className="truncate" data-id="element-382">
                      {cat.ctaLabel || t.vehicles.cta}
                    </span>
                    <ArrowRightIcon className="w-4 h-4 flex-shrink-0" data-id="element-383" />
                  </button>

                  <p className="text-center text-[11px] text-gray-400 mt-3 font-medium tracking-wide" data-id="element-384">
                    {t.vehicles.microcopy}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default VehicleRecommendations;